export default `
§ uiKit.dataLoader.page: Страница
§ uiKit.dataLoader.size: Отображается по
§ uiKit.dataLoader.from: из
§ uiKit.dataLoader.all: Показать все
§ common.viewType.cards: Отобразить карточками
§ common.viewType.table: Отобразить таблицой
§ common.viewType.tsable: Отобразить таблицой
`;
